import type { KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';
import { isKycSubmitted } from './is-kyc-submitted';
import { isKycRequired } from './is-kyc-required';

export function shouldSubmitKyc(kycInfo: KycResponse) {
  return isKycRequired(kycInfo) && !isKycSubmitted(kycInfo);
}
